import './App.css';
import React, { useContext, useEffect, useState } from 'react';
import {Route, Routes, useLocation, useNavigate} from 'react-router-dom'
import Home from './Pages/Home/Home';
import Directory from './Pages/Directory/Directory';
import ListingEditor from './Pages/ListingEditor/ListingEditor';
import PortfolioPage from './Pages/PortfolioPage/PortfolioPage';
import PrivacyTermsAndConditions from './Pages/PrivacyTermsAndConditions/PrivacyTermsAndConditions';
import MembershipBenefits from './Pages/MembershipBenefits/MembershipBenefits';
import AdminPage from './Pages/AdminPage/AdminPage';
import usePageTracking from './Hooks/usePageTracking';
import CookieConsent from './Components/CookieConsent';
import { UserContext } from "./Contexts/UserContext";
import { AuthContext } from "./Contexts/AuthContext";
import { Masthead } from '@nxtvid/component-library';
import { SignUpInfoContext } from './Contexts/SignUpInfoContext';
import { newRegistration } from './Services/newRegistration.js';
import signOut from './Services/signOut.js';
import { signIn } from './Services/signIn.js';
import { resetPassword } from './Services/resetPassword.js';
import { MastheadRefContext } from './Contexts/MastheadRefContext.js';


function App() {
  
  const {isAuthenticated, setIsAuthenticated} = useContext(AuthContext)
  const {userInfo, setUserInfo} = useContext(UserContext)
  const {signUpInfo, setSignUpInfo} = useContext(SignUpInfoContext)
  const {mastheadRef} = useContext(MastheadRefContext)

  usePageTracking();

  const RedirectToHome = () => {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
      if (location.pathname !== "/") {
        navigate("/", { replace: true });
      }
    }, [location, navigate]);
  
    return null;
  };
  
  

  useEffect(()=>{
      const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
      fetch(`${API_BASE_URL}/api/validate-token`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
        },
      })
        .then(response => response.json())
        .then(data => {
          console.log('validated')
          setIsAuthenticated(data.isValid); // Update state based on response
        })
        .catch(error => {
          console.error('Error validating token:', error);
          setIsAuthenticated(false); // Set to false if there's an error
        });
        
        fetch(`${API_BASE_URL}/api/getUserInfo`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
          },
        })
          .then(response => response.json())
          .then(data => {
            setUserInfo(data)
          })
          .catch(error => {
            console.error('Error validating token:', error);
            setIsAuthenticated(false); // Set to false if there's an error
            
          });
    
  }, [])

  
  return (
    <>
    {process.env.REACT_APP_ENV == 'development' ? <></> : <CookieConsent/>}
    <Masthead ref={mastheadRef} isAuthenticated = {isAuthenticated} userInfo={userInfo} signOut = {signOut} site = 'marketplace' signUpInfo = {signUpInfo} setSignUpInfo={setSignUpInfo} newRegistration = {(value)=>newRegistration(value)} signIn = {(value)=>signIn(value)} passwordReset = {(value)=>resetPassword(value)}/>
      <div id='modal-root'/>
      <Routes>
        <Route exact path ='/' element = {<Home/>}/>
        <Route path = '/Directory' element = {<Directory/>}/>
        <Route path = '/ListingEditor' element = {<ListingEditor/>}/>
        <Route path = "/Portfolios/:companyUrl" element = {<PortfolioPage/>}/>
        <Route path ="/Legal" element = {<PrivacyTermsAndConditions/>}/>
        <Route path ='/MembershipBenefits' element = {<MembershipBenefits/>}/>
        <Route path ='/Admin' element = {<AdminPage/>}/>
        <Route path="*" element={<div>404 Page Not Found</div>} />
      </Routes>
      </>
  );
}

export default App;
